import LeftHandMenu from "./LeftHandMenu";

export default LeftHandMenu;
